<template>
  <div class="card-detalhes-produto-cliente">      
    <g-card class="card-consultas-produtos-cliente" :temCabecalho="false" :expansivel="false">
      <div class="header-detalhes-secundario">
        <div class="header-detalhes-secundario-titulo">
          <g-button
            class="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="retornaTelaProdutosCliente"
          />
          <div class="titulo-detalhes-cabecalho"> Detalhes </div>
        </div>
      </div>

      
      
      <div class="conteudo-card-detalhes-produto-cliente espacamento-detalhes">
        

        <div class="dados-produto-titulo titulo-grupo-detalhes"> Dados do Produto </div>
        <div class="tudo-dados-produto">
          <div class="imagem-lado-a-lado">
        <div class="img-container-mobile" >
            <div class="img-box-mobile" >
              <PImage :imageStyle="styleImg" v-on:error="erro($event)" :src="caminhoImagem" :preview="true">
              </PImage>
              <div class="img-info-mobile" v-if="this.styleImg.includes('100')"> NENHUMA IMAGEM DISPONÍVEL! </div>
            </div>
        </div>

        <div style="border-left: 2px solid rgb(138 138 138 / 48%); margin-right: 2rem"> </div>
          <div class="grupo-dados-produto" >
            <div class="dados-produto-cliente">
              <div class="titulo-conteudo-detalhes"> Cliente </div>
              <div class="label-conteudo">{{ codigoExterno }} - {{ nomeFantasia }}</div>
          </div>

          <div class="dados-produto-unidade">
            <div class="titulo-conteudo-detalhes"> Unidade </div>
            <div class="label-conteudo">{{ nomeEmpresa }}</div>
          </div>

          <div class="dados-produto-produto">
            <div class="titulo-conteudo-detalhes"> Produto </div>
            <div class="label-conteudo">{{ codigoProduto }} - {{ nomeProduto }}</div>
          </div>

          <div class="dados-produto-dataFaturamento">
            <div class="titulo-conteudo-detalhes"> Data do último faturamento </div>
            <div class="label-conteudo">{{ dataUltimoFaturamentoFormatada }}</div>
          </div>

          <div class="dados-produto-dataVenda">
            <div class="titulo-conteudo-detalhes"> Data última venda </div>
            <div class="label-conteudo">{{ dataUltimaVendaFormatada }}</div>
          </div>

          <div class="dados-produto-porcentagem-ipi">
            <div class="titulo-conteudo-detalhes"> Porcenta. do IPI </div>
            <div class="label-conteudo"> {{ ipi }}% </div>
          </div>

          <div class="dados-produto-produto-linha">
            <div class="titulo-conteudo-detalhes"> Produto está em linha </div>
            <div class="label-conteudo">{{ emLinha }}</div>
          </div>

          <div class="dados-produto-produto-selo">
            <div class="titulo-conteudo-detalhes"> Produto possui selo FSC? </div>
            <div class="label-conteudo">{{ fsc || 'Não' }}</div>
          </div>
        </div>
      </div>
    </div>

        <!-- fimmmmmmmmmmmm -->

        <div class="container-componentes">
          <div class="titulo-grupo-detalhes titulo-componentes" v-if="this.componentesLista.length > 0"> COMPONENTES </div>

          <div class="content-componentes">
            <div 
              class="box-componente" 
              v-for="(data, index) in componentesLista"
              :key="data"
            >
              <div class="imagem-numero-nome-componente">
                <div class="imagem-grupo-componente">
                  <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                </div>
                        
                <div class="numero-nome-componente">
                  <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ index + 1 }}</div>
                  <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
                </div>
              </div> 

              <div class="grupo-componentes">
                <div class="componentes-medidas">
                  <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                  <div class="medidas label-conteudo">
                    {{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)   ? data.numeroComprimento + ' x ' + data.numeroLargura + ' x ' + data.numeroAltura +  ' x ' + data.numeroAlturaTampa : data.descricaoMedidasTexto }}
                  </div>
                </div>

                <div class="componentes-cor-frente">
                  <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                  <div class="corFrente label-conteudo">{{data.quantidadeCoresFrente != 1 ? data.quantidadeCoresFrente + ' Cores' + '  ' + data.nomeCorFrente  : data.quantidadeCoresFrente + ' Cor' + '   ' + data.nomeCorFrente }} </div>
                </div>

                <div class="componentes-cor-verso">
                  <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                  <div class="corVerso label-conteudo">{{data.quantidadeCoresVerso != 1 ? data.quantidadeCoresVerso + ' Cores' +  '   ' +  data.nomeCorVerso : data.quantidadeCoresVerso + ' Cor'  + '  ' + data.nomeCorVerso}}</div>
                </div>

                <div class="componentes-acabFrente">
                  <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                  <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
                </div>

                <div class="componentes-acabVerso">
                  <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                  <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
                </div>

                <div class="componentes-material">
                  <div class="material titulo-conteudo-detalhes"> Material </div>
                  <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
                </div>

                <div class="componentes-onda">
                  <div class="onda titulo-conteudo-detalhes"> Onda </div>
                  <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
                </div>

                <div class="componentes-capaExt">
                  <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                  <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
                </div>

                <div class="componentes-gramaturaExt">
                  <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaExt label-conteudo">{{ data.numeroGramaturaCapaExterna }}</div>
                </div>

                <div class="componentes-capaInt">
                  <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                  <div class="capaInt label-conteudo">{{data.descricaoCapaInternaTexto}}</div>
                </div>

                <div class="componentes-gramaturaInt">
                  <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaInt label-conteudo">{{ data.numeroGramaturaCapaInterna }}</div>
                </div>

                <div class="componentes-papelOnda">
                  <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                  <div class="papelOnda label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
                </div>

                <div class="componentes-gramaturaPO">
                  <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaPO label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
                </div>

                <div class="componentes-codigo">
                  <div class="codigo-componente titulo-conteudo-detalhes"> N° Repetições </div>
                  <div class="label-conteudo">{{ data.numeroRepeticoes }}</div>
                </div>

                <div class="componentes-descricao">
                  <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                  <div class="label-conteudo">{{ data.sistema }}</div>
                </div>

                <div class="">
                  <div class="gramaturaPO titulo-conteudo-detalhes"> Linha de Produção </div>
                  <div class="gramaturaPO label-conteudo">{{ data.nomeLinha }}</div>
                </div>

                <div class="componentes-embalagem-coletiva" 
                  v-if="data.embalagemEspecificaPalete == true || 
                  data.embalagemEspecificaFilmeEncolhivel == true || 
                  data.embalagemEspecificaCaixaColetiva == true || 
                  data.embalagemEspecificaPapelEmbrulho == true || 
                  data.quantidadeOutros != 0"
                >
                  <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                  <div class="labels-embalagem-coletiva">
                    <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                    >
                      {{ texto }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="observacao-titulo titulo-grupo-detalhes"> Observação </div>
        <div class="grupo-observacao topico">
          <div class="observacao-grupo-observacao">
            <div class="label-conteudo">{{observacaoGeral || 'Não há observações para esse produto.'}}</div>
          </div>
        </div>

        <div class="critica-titulo titulo-grupo-detalhes"> Críticas de Processo </div>
        <div class="input-checkbox critica-container topico">
          <label for="fechamento-maquina" class="criticaProcesso label-checkbox"> O produto terá fechamento por máquina por parte do cliente? </label> 
          <label :class="`label-checkbox critica-bool ${OrcamentoCritica3 ? 'botao-positivo' : 'botao-negativo'}`" for="fechamento-maquina">
            {{ OrcamentoCritica3 ? "SIM" : "NÃO" }}
          </label>
        </div>
      </div>

    </g-card>
    

  </div>
  
</template>

<script>
import DetalhesProdutosCliente from './DetalhesProdutosCliente.js' 
export default DetalhesProdutosCliente
</script>


<style scoped>
.imagem-lado-a-lado{
  display: flex;
  flex-direction: row-reverse;
  justify-content: left;
}

.img-container-mobile{
  flex: 8
}

.tudo-dados-produto{
  flex: 2
}

.grupo-dados-produto, .grupo-componentes, .grupo-observacao {
  border-bottom: none;
  margin-top: 10px;
}

.content-componentes {
  width: 100%;
  display: grid;
  gap: 1.5rem;
}
.box-componente {
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 0.2rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-componente .grupo-componentes {
  display: grid;
  grid-auto-rows: auto;
  grid-column-gap: 1rem;
}

.titulo-componentes {
    margin-bottom: 1.5rem;
}
.imagem-numero-nome-componente {
  display: flex;
  column-gap: 1rem;
}
.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19 !important;
  font-size: 0.9rem !important;
}

.titulo-conteudo-detalhes {
  color: #3f3f3f;
  margin-top: 0.1rem;
}

.labels-embalagem-coletiva {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
  width: 100%;
}

.label-checkbox {
  color: #8a8a8a;
  text-align: left;
  font-family: "MontSerrat";
  margin-left: 5px;
}

.checkbox {
  display: flex;
  padding-top: 10px;
}

.topico {
  padding-bottom: 20px;
}

.topico-obs{
  padding-bottom: 20px;
}

.critica-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0.5rem;
}

.critica-container {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.critica-bool {
  color: #F9F9F9;
  width: max-content;
  padding: 0.2rem 1rem;
  border-radius: 0.2rem;
}

.botao-positivo {
  background-color: #3dca55;
}
.botao-negativo {
  background-color: #DC4242;
}


@media(min-width:310px) {
  .grupo-dados-produto {
    display: grid;
    grid-template-columns: repeat(1, minmax(4em, 1fr));
    grid-template-rows: repeat(7, auto);
    column-gap: 3%;
    row-gap: 0.8rem;
  }

  .topico {
    display: flex;
    flex-wrap: wrap;
    column-gap: 8%;
  }

  .critica-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .img-componente {
    height: 2.5rem;
    width: auto;
  }

  .container-componentes .titulo-conteudo-detalhes, .container-componentes .label-conteudo {
    font-size: 0.8rem;
  }
}


@media(min-width:368px) {}

@media (min-width: 450px) {
.box-componente .grupo-componentes {
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
}
.componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.componentes-material { grid-area: 4 / 1 / 5 / 2; }
.componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
.componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
.componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
.componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
.componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }
.componentes-nomeLinha { grid-area: 8 / 3 / 9 / 4; }

}

@media (min-width:500px) {
.container-componentes .titulo-conteudo-detalhes, .container-componentes .label-conteudo {
  font-size: 0.9rem;
}

.componentes-embalagem-coletiva { 
  grid-column: span 2; 
}
}

@media(min-width:600px) {
  .grupo-dados-produto {
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    row-gap: 0;
  }

  .content-componentes {
    grid-template-columns: repeat(2, minmax(2rem, 1fr));
  }

  .componentes-produto, 
  .componentes-embalagem-coletiva { grid-column: span 2; } 
}


@media(min-width:801px) {
  .grupo-dados-produto {
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
  }
}


@media(min-width:1025px) {
  .content-componentes {
    column-gap: 4rem;
  }

  .imagem-numero-nome-componente {
    padding: 0.5rem 1rem;
  }

  .grupo-componentes {
    padding: 0 1rem;
  }
}


@media(min-width:1285px) {
  .grupo-dados-produto {
    grid-template-columns: repeat(5, minmax(4em, 1fr));
  }
}

@media(min-width:1500px) {
  .content-componentes {
    grid-template-columns: repeat(4, minmax(2rem, 1fr));
  }

}

@media (min-width:1800px) {}

@media (min-width:2000px) {}

</style>